/**
 * Pantalla de error reutilizable (404 "Página no encontrada", 403 "Sin acceso", 500 "Algo salió mal", 401 "Archivo protegido"), con la estética del
 * login: mismo fondo degradé, tarjeta blanca centrada, Montserrat en títulos e Inter en texto. Estilos: styles/paginaError.css.
 * No muestra la dirección pedida ni datos técnicos.
 *
 *   <PaginaError tipo={404} />
 *   <PaginaError tipo={403} cerrarSesionAlVolver />   // el usuario no tiene un rol que pueda usar la app: "Volver" cierra su sesión
 *   <PaginaError tipo={500} />                        // "Reintentar" recarga la página (lo usa ErrorBoundary)
 */
import React from 'react';
import '../styles/login.css';
import '../styles/paginaError.css';
import { TIPOS_ERROR, destinoInicio, haySesion } from '../utils/errorPagina';

const PaginaError = ({ tipo = 404, cerrarSesionAlVolver = false }) => {
  const e = TIPOS_ERROR[tipo] || TIPOS_ERROR[404];

  const alReintentar = () => window.location.reload();
  const alVolver = () => {
    if (cerrarSesionAlVolver) {
      try {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('usuario');
      } catch (err) { /* sin sessionStorage: igual se va al login */ }
    }
  };
  const destino = (cerrarSesionAlVolver || e.accion === 'login') ? '/login' : destinoInicio({ token: haySesion() ? 'si' : null });

  return (
    <div className="login-container">
      <div className="login-gradient"></div>

      <main className="error-page-card" role="main">
        <img src="/logo-betech.svg" alt="Betech" className="error-page-logo" width="52" height="52" />

        <div className="error-page-codigo" aria-hidden="true">{e.codigo}</div>
        <h1 className="error-page-titulo">
          <span className="error-page-solo-lector">Error {e.codigo}: </span>{e.titulo}
        </h1>
        <p className="error-page-mensaje">{e.mensaje}</p>

        {e.accion === 'reintentar' ? (
          <button type="button" className="error-page-boton" onClick={alReintentar}>{e.boton}</button>
        ) : (
          <a className="error-page-boton" href={destino} onClick={alVolver}>{e.boton}</a>
        )}

        <footer className="error-page-pie">
          © 2026 Betech Solutions | <a href="https://www.be-tech.com.ar" target="_blank" rel="noopener noreferrer">www.be-tech.com.ar</a>
        </footer>
      </main>
    </div>
  );
};

export default PaginaError;
